import { Linkedin, Mail, Phone } from "lucide-react";

interface TeamCardProps {
  name: string;
  title: string;
  description: string;
  image: string;
  linkedin?: string;
  email?: string;
  phone?: string;
}

const TeamCard = ({
  name,
  title,
  description,
  image,
  linkedin,
  email,
  phone,
}: TeamCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="h-64 bg-gray-200 overflow-hidden">
        <div className="w-full h-full flex items-center justify-center text-gray-400">
          {/* Using a div with background image instead of an img tag for consistency */}
          <div 
            className="w-full h-full bg-cover bg-center"
            style={{ backgroundImage: `url(${image})` }}
            role="img"
            aria-label={`Photo of ${name}`}
          ></div>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-lg font-heading font-semibold text-neutral-800">{name}</h3>
        <p className="text-accent mb-3">{title}</p>
        <p className="text-neutral-800 mb-4">{description}</p>
        <div className="flex space-x-3">
          {linkedin && (
            <a 
              href={linkedin} 
              className="text-primary hover:text-primary/80 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${name}'s LinkedIn profile`}
            >
              <Linkedin size={18} />
            </a>
          )}
          {email && (
            <a 
              href={`mailto:${email}`} 
              className="text-primary hover:text-primary/80 transition-colors"
              aria-label={`Email ${name}`}
            >
              <Mail size={18} />
            </a>
          )}
          {phone && (
            <a 
              href={`tel:${phone}`} 
              className="text-primary hover:text-primary/80 transition-colors"
              aria-label={`Call ${name}`}
            >
              <Phone size={18} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
